import { saveAs } from 'file-saver';
import {HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';

export default class RelatorioUtils {

    static download(response: any, nomeArquivo: string, formato: string): Observable<any> {

        return new Observable(subscriber => {
            try {
                const blob = new Blob([response], {
                    type: 'application/' + formato
                });
        
                saveAs(blob, nomeArquivo);
                subscriber.next(response);
                subscriber.complete();

            } catch (error) {
                subscriber.error(new Error(`Erro ao baixar o arquivo: ${(error as Error).message}`));
            }
        })

    }

    static downloadPdf(response: any, nomeArquivo: string): Observable<any> {
        return RelatorioUtils.download(response, nomeArquivo, 'pdf');
    }

    static exibirHtml(response: Response):void {
        if (response.body) {
            response.arrayBuffer().then(buffer => {
                const blob = new Blob([buffer], { type: 'text/html' });
                const fileUrl = URL.createObjectURL(blob);
                window.open(fileUrl);
            });
        }
    }

    static criarParametrosRelatorios(): any {
        const headersHttp = new HttpHeaders();
        headersHttp.append('Content-Type', 'application/json');
        headersHttp.append('Accept', 'application/octet-stream');

        return {
            headers: headersHttp,
            responseType: 'arraybuffer'
        };
    }
}
